export default "__VITE_ASSET__Dzi3Zl41__"